import cn from 'classnames'
import { configuration } from 'mmfintech-backend-api'
import { getCurrencyImageUrl } from 'mmfintech-commons'
import type React from 'react'
import './CurrencyIcon.scss'

interface Props {
  currency: string
  size?: string
  circle?: boolean
  className?: string
}

function CurrencyIcon({ currency, size = '3rem', circle, className }: Props) {
  return (
    <span
      className={cn('currency-icon-wrapper', className, { circle })}
      style={{ '--icon-size': size } as React.CSSProperties}
    >
      <img src={`${configuration.getBaseUrl()}${getCurrencyImageUrl(currency, 'svg')}`} alt='' />
    </span>
  )
}

export default CurrencyIcon
